"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferLiquidityCheckAdapterStorageV4Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowedDex",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "erc20TokenToTTokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "flashLoanAndLiquidateSlippageTolerance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lavaBarLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oracles",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tTokenToErc20TokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vvs",
        outputs: [
            {
                internalType: "contract IVVSRouter02",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wowmaxRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610267806100206000396000f3fe608060405234801561001057600080fd5b50600436106100835760003560e01c806308e77344146100885780632a2c372e146100b85780633395635d146100cb5780638a70e439146100fe5780638db35baa14610132578063ad5c464814610149578063addd50991461015c578063c7fb1c7214610185578063d3393e70146101b9575b600080fd5b60015461009b906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b60085461009b906001600160a01b031681565b6100ee6100d93660046101de565b60076020526000908152604090205460ff1681565b60405190151581526020016100af565b61009b61010c3660046101ff565b60036020908152600092835260408084209091529082529020546001600160a01b031681565b61013b60045481565b6040519081526020016100af565b60005461009b906001600160a01b031681565b61009b61016a3660046101de565b6002602052600090815260409020546001600160a01b031681565b61009b6101933660046101ff565b60056020908152600092835260408084209091529082529020546001600160a01b031681565b61013b60065481565b80356001600160a01b03811681146101d957600080fd5b919050565b6000602082840312156101ef578081fd5b6101f8826101c2565b9392505050565b60008060408385031215610211578081fd5b61021a836101c2565b9150610228602084016101c2565b9050925092905056fea264697066735822122045ea65915ec8ae7d7ac157e55c5b42d3a2c970d6dd307d3ef66374e16ec25bc164736f6c63430008030033";
class DeferLiquidityCheckAdapterStorageV4Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DeferLiquidityCheckAdapterStorageV4Factory = DeferLiquidityCheckAdapterStorageV4Factory;
DeferLiquidityCheckAdapterStorageV4Factory.bytecode = _bytecode;
DeferLiquidityCheckAdapterStorageV4Factory.abi = _abi;
//# sourceMappingURL=DeferLiquidityCheckAdapterStorageV4Factory.js.map